import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { BADGE_ASSIGNMENT_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function delete_badge_assignee_attribute_by_pk(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(BADGE_ASSIGNMENT_CACHE_FIELDS, cache);
}
